import { useMemo } from 'react';
import { useQueryParam } from '../../../utils/hooks/useQueryParam';
import { allGenresValue, genreParamName } from '../components/SMLGenreSelector/consts';

export const useSMLGenreParam = () => {
  const genreParam = useQueryParam(genreParamName, null, '');
  const genre = useMemo(() => {
    const raw = (genreParam ?? '').trim();
    if (raw === '' || raw === allGenresValue) {
      return undefined;
    }
    return raw;
  }, [genreParam]);
  return { genre, genreParamValue: genre ?? allGenresValue };
};
